"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBasisTheoryFromContext = exports.BasisTheoryProvider = void 0;
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const BasisTheoryContext = /*#__PURE__*/(0, _react.createContext)({});
const BasisTheoryProvider = ({
  bt,
  children
}) => {
  const value = (0, _react.useMemo)(() => ({
    bt
  }), [bt]);
  return /*#__PURE__*/_react.default.createElement(BasisTheoryContext.Provider, {
    value: value
  }, children);
};
exports.BasisTheoryProvider = BasisTheoryProvider;
const useBasisTheoryFromContext = () => (0, _react.useContext)(BasisTheoryContext);
exports.useBasisTheoryFromContext = useBasisTheoryFromContext;